import { render, staticRenderFns } from "./LedgerView.vue?vue&type=template&id=503e040d&scoped=true"
import script from "./LedgerView.vue?vue&type=script&lang=js"
export * from "./LedgerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "503e040d",
  null
  
)

export default component.exports